var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBCerrar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M259.38 247.495C235.215 223.33 211.05 199.165 186.885 175C204.287 157.598 221.689 140.196 239.091 122.795C245.567 116.318 252.043 109.842 258.519 103.366C266.178 95.7078 254.296 83.8191 246.634 91.4807C222.756 115.359 198.878 139.237 175 163.115C157.233 145.348 139.466 127.581 121.699 109.813C115.301 103.416 108.903 97.0173 102.505 90.6198C94.8465 82.9611 82.958 94.8429 90.6196 102.505C114.785 126.67 138.95 150.835 163.115 175C145.713 192.402 128.311 209.804 110.909 227.206C104.433 233.682 97.957 240.158 91.4809 246.634C83.8225 254.293 95.7043 266.181 103.366 258.519C127.244 234.641 151.122 210.763 175 186.885C192.767 204.652 210.534 222.42 228.302 240.187C234.699 246.585 241.097 252.982 247.495 259.381C255.154 267.039 267.042 255.157 259.38 247.495Z",
    fill: "#3743AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBCerrar);
export default __webpack_public_path__ + "static/media/B_Cerrar.222753507afbef2a1540fb7bb1103419.svg";
export { ForwardRef as ReactComponent };